@if (visible()) {
    <div class="anc-viewport-notice" role="status">
        <span class="anc-viewport-notice__icon icon icon-info" aria-hidden="true"></span>
        <span class="anc-viewport-notice__text">{{ message() | translate }}</span>
        <button
            type="button"
            class="anc-viewport-notice__close"
            [attr.aria-label]="'Close' | translate"
            (click)="dismiss()"
        >
            <span class="icon icon-x" aria-hidden="true"></span>
        </button>
    </div>
}
